import { ArrowRightIcon } from '@heroicons/react/20/solid';

import srcHeroPattern from './images/hero-pattern.svg';
import Testimonials from './Testimonials';

export default function Hero() {
  return (
    <div className="relative isolate overflow-hidden">
      {/* eslint-disable-next-line tailwindcss/no-custom-classname */}
      <div className="bg-repeat" style={{ backgroundImage: `url('${srcHeroPattern}')` }}>
        <div className="border-b border-zinc-600/80 bg-gradient-to-bl from-emerald-400/50 to-70% px-4 lg:px-8">
          <div className="mx-auto max-w-6xl pb-12 pt-32 sm:py-24">
            {/* <div className="hidden sm:mb-8 sm:flex sm:justify-center">
              <div className="mt-16 rounded px-3 py-1 text-sm leading-6 text-zinc-300 ring-1 ring-zinc-300/30 hover:ring-zinc-300/40">
                Our college basketball service is now available.{' '}
                <a
                  href="/order"
                  className="inline-flex flex-row items-center gap-x-2 font-semibold text-emerald-400 hover:text-emerald-500"
                >
                  <span>Join us</span> <ArrowRightIcon className="h-4 w-4" aria-hidden="true" />
                </a>
              </div>
            </div> */}
            <div className="text-center sm:mt-24">
              <h1 className="mx-auto max-w-md text-center text-4xl font-bold tracking-normal text-white sm:max-w-2xl sm:text-7xl sm:leading-none sm:tracking-tight">
                A pick service that <i>actually</i> wins
              </h1>
              <p className="my-auto mt-10 inline-block max-w-prose text-center text-base leading-6 text-white/70 sm:max-w-2xl sm:text-lg sm:leading-8 md:text-xl">
                College basketball season is now live.
              </p>
              <div className="mt-10 flex flex-col items-center justify-center space-y-4 sm:mb-20 sm:flex-row sm:space-x-6 sm:space-y-0">
                <a
                  className="inline-flex w-full justify-center space-x-0.5 overflow-hidden rounded bg-emerald-400/10 px-6 py-3 text-base font-medium text-emerald-400 ring-1 ring-inset ring-emerald-400 delay-150 ease-in-out hover:bg-emerald-400/10 hover:text-emerald-300 hover:ring-emerald-300 sm:w-auto"
                  href="/register"
                >
                  Get free picks
                </a>
                {/* <a
                  className="inline-flex w-full items-center justify-center space-x-1 overflow-hidden rounded px-6 py-3 text-base font-medium text-zinc-200 ring-1 ring-inset ring-white/10 transition hover:bg-white/5 hover:text-white sm:w-auto"
                  href="/order"
                >
                  <span>Subscribe now</span>
                  <ArrowRightIcon className="h-4 w-4" />
                </a> */}
              </div>
              <Testimonials />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
